

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useContext } from "react";
import { AuthenticationContext } from "../../context/AuthenticationContext";

const ExportExcel = async (ImageUrl, logData, Dt1, Dt2,radiationName,LoggedInUserInfo) => {
  
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet(`${radiationName}`);

  try {
    // ===== Load uploaded image (static file instead of API) =====
    const response = await fetch(ImageUrl);
    const blob = await response.blob();
    const base64Logo = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
    });

    // ===== Add image to Excel =====
    const logo = workbook.addImage({
      base64: base64Logo,
      extension: "png",
    });

    worksheet.mergeCells("A1:D4"); // Logo space
    worksheet.addImage(logo, {
      tl: { col: 0, row: 0 },
      ext: { width: 250, height: 65 },
    });

    // ===== Company Info =====
    const companyName = LoggedInUserInfo?.username || "";
    const companyAddress = LoggedInUserInfo?.Address || "";

    worksheet.mergeCells("F1:P2");
    worksheet.getCell("F1").value = `Plant Name/User Name: ${companyName}`;
    worksheet.getCell("F1").font = { size: 14, bold: true };
    worksheet.getCell("F1").alignment = { vertical: "middle", horizontal: "left" };

    worksheet.mergeCells("F3:P4");
    worksheet.getCell("F3").value = `Plant Address: ${companyAddress}`;
    worksheet.getCell("F3").font = { size: 11, color: { argb: "555555" } };
    worksheet.getCell("F3").alignment = { vertical: "middle", horizontal: "left" };

  } catch (error) {
    console.error("Logo fetch/convert error:", error);
  }

  // ===== Table Header + Data =====
  worksheet.addRow([]);
  worksheet.addRow(Object.keys(logData[0] || {}));
  logData.forEach((item) => {
    worksheet.addRow(Object.values(item));
  });

  // ===== Export file =====
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(
    new Blob([buffer]),
    `${radiationName} ${LoggedInUserInfo?.username} From ${Dt1} To ${Dt2}.xlsx`
  );
};

export default ExportExcel;
